import { Badge, Box, Button, Text } from "rizzui";
import { Client } from "@/types";
import ControlledTable from "@/components/controlled-table";
import { HeaderCell } from "@/components/legacy-table";
import { formatDate } from "@/utils/format-date";
import GenericModal from "@/components/common/GenericModal";
import { RemoveClient } from "@/server/api-services";
import { toast } from "react-hot-toast";
import { PiEye, PiTrash } from "react-icons/pi";
import { Link } from "react-router-dom";
import routes from "@/routers/routes";

type ClientListTableProps = {
    clients: Client[];
    refresh(): void;
};

export default function ClientsListTable({
    clients,
    refresh,
}: ClientListTableProps) {
    const deleteClient = async (id: string) => {
        const response = await RemoveClient(id);
        if (response.statusCode !== 200) {
            toast.error("Failed to delete client");
            return;
        }
        toast.success("Client deleted successfully");
        refresh();
    };

    const getColumns = () => [
        {
            title: <span className="ms-6 block whitespace-nowrap">Date</span>,
            dataIndex: "createdDate",
            key: "createdDate",
            width: 200,
            render: (createdDate: string) => (
                <span className="ms-6 block">
                    <Text className="mb-1 font-medium text-gray-700">
                        {formatDate(new Date(createdDate), "MMMM D, YYYY")}
                    </Text>
                    <Text className="text-[13px] text-gray-500">
                        {formatDate(new Date(createdDate), "h:mm A")}
                    </Text>
                </span>
            ),
        },
        {
            title: <HeaderCell title="Full Name" />,
            dataIndex: "fullname",
            key: "fullname",
            width: 200,
            render: (fullname: string) => <Text>{fullname}</Text>,
        },
        {
            title: <HeaderCell title="Email" />,
            dataIndex: "email",
            key: "email",
            width: 200,
            render: (email: string) => <Text>{email}</Text>,
        },
        {
            title: <HeaderCell title="Mobile" />,
            dataIndex: "mobile",
            key: "mobile",
            width: 200,
            render: (mobile: string) => <Text>{mobile}</Text>,
        },
        {
            title: <HeaderCell title="Client Type" />,
            dataIndex: "clientType",
            key: "clientType",
            width: 200,
            render: (clientType: string) => (
                <Badge variant="flat" color="success" size="sm">
                    {clientType}
                </Badge>
            ),
        },
        {
            title: <HeaderCell title="gender" />,
            dataIndex: "gender",
            key: "gender",
            width: 200,
            render: (gender: string) => <Text>{gender}</Text>,
        },
        {
            title: <HeaderCell title="Actions" />,
            dataIndex: "id",
            key: "id",
            width: 200,
            render: (id: string) => (
                <div className="flex items-center gap-4">
                    <Link to={routes.clients.details(id)}>
                        <Button variant="flat" color="primary" size="sm">
                            <PiEye className="h-auto w-6" />
                        </Button>
                    </Link>
                    <GenericModal
                        onConfirm={() => deleteClient(id)}
                        icon={<PiTrash className="h-auto w-6" />}
                        title="Delete"
                        size="sm"
                        buttonType="flat"
                        color="danger"
                        description="Are you sure you want to delete billing"
                    />
                </div>
            ),
        },
    ];

    return (
        <Box>
            {/* <Filters table={table} /> */}
            <ControlledTable
                data={clients}
                columns={getColumns()}
                scroll={{ x: "100%", y: 240 }}
                sticky={true}
                variant="modern"
                className="mt-4"
            />
        </Box>
    );
}
